import {Component, Input} from '@angular/core';
import {Router} from '@angular/router';
import {CardComponent} from '../../../../../shared/components/card/card.component';
import {MatButton} from '@angular/material/button';
import {CardContentDirective} from '../../../../../shared/components/card/card-content.directive';

@Component({
  selector: 'app-manage-cartegraph-header',
  templateUrl: './cartegraph-header.component.html',
  styleUrls: ['../../../settings-fields.scss',
    '../../../settings-common.scss'],
  imports: [
    CardComponent,
    MatButton,
    CardContentDirective
  ],
  standalone: true
})
export class CartegraphHeaderComponent {

  @Input()
  page: string;

  PageType = PageType;

  constructor(private router: Router) {
  }

  navigateToImports() {
    this.router.navigate(['settings/cartegraph-settings/imports']).then();
  }

  navigateToSettings() {
    this.router.navigate(['settings/cartegraph-settings/settings']).then();
  }

  navigateToSubmissions() {
    this.router.navigate(['settings/cartegraph-settings/submissions']).then();
  }

}

export enum PageType {
  SETTINGS = 'SETTINGS',
  SUBMISSIONS = 'SUBMISSIONS',
  IMPORTS = 'IMPORTS',
}
